import ListItem from "@mui/material/ListItem";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import PublicIcon from "@mui/icons-material/Public";
import { Box, Chip, ListItemIcon, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { DELTA_ACCENT, STATUS_GREEN, STATUS_GREY, TEXT_SECONDARY } from "../colors";
import * as Utilities from "../../data/utilities";

export const AppointmentItem = (props: { data: any }) => {
  const { data } = props;
  const isActive = data.resigned_on === undefined;

  return (
    <ListItem disableGutters style={{ borderBottom: "1px solid #E2E2E7", paddingBottom: 12, marginBottom: 12 }}>
      <ListItemIcon>
        {data.company_type === "plc" ? (
          <PublicIcon style={{ color: DELTA_ACCENT }} />
        ) : (
          <BusinessCenterIcon style={{ color: DELTA_ACCENT }} />
        )}
      </ListItemIcon>
      <Box style={{ flex: 1 }}>
        <Box style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Link
            to={"/company/" + data.appointed_to.company_number}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Typography variant="subtitle1">
              {data.appointed_to.company_name} ({data.appointed_to.company_number})
            </Typography>
          </Link>
          <Chip
            label={isActive ? "Active" : "Resigned"}
            size="small"
            style={{
              backgroundColor: isActive ? STATUS_GREEN : STATUS_GREY,
              color: "white",
            }}
          />
        </Box>
        <Typography variant="body2" style={{ color: TEXT_SECONDARY, marginTop: 4 }}>
          {data.occupation}
        </Typography>
        <Typography variant="body2" style={{ color: TEXT_SECONDARY }}>
          Appointed On: {Utilities.getDateDisplay(data.appointed_on)}
        </Typography>
        {data.resigned_on != undefined && (
          <Typography variant="body2" style={{ color: TEXT_SECONDARY }}>
            Resigned On: {Utilities.getDateDisplay(data.resigned_on)}
          </Typography>
        )}
      </Box>
    </ListItem>
  );
};
